import { useTranslation } from 'react-i18next';

const FamilyBuildingSurrogacySupport = ({ prevStep, handleChange, formData, nextStep,error,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();
  const supportOptions = [
    "Understanding benefits and coverage",
    "Agency or provider referrals",
    "Financial planning and reimbursements",
    "Legal considerations",
    "Emotional or mental health support",
    "Care coordination and next steps",
  ];

  const selectedSupportOptions = Array.isArray(formData.SurrogacySupport)
    ? formData.SurrogacySupport
    : formData.SurrogacySupport
    ? [formData.SurrogacySupport]
    : [];

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    const updatedSelections = checked
      ? [...selectedSupportOptions, value]
      : selectedSupportOptions.filter((item) => item !== value);

    handleChange({
      target: {
        name: 'SurrogacySupport',
        value: updatedSelections,
      },
    });
  };

  return (
    <>
      <div className="step-section">
        <div className="surrogacy-journey-label">Surrogacy Journey</div>
        <h3 className="page-heading-secondary-black-500 mb-5">Which aspects of surrogacy would you like to support with right now?</h3>
        {supportOptions.map((option, index) => {
          const optionId = `surrogacySupport${index + 1}`;

          return (
            <div key={option} className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
              <input
                type="checkbox"
                className="form-check-input radio-btn win-form-check-input"
                name="SurrogacySupport"
                id={optionId}
                value={option}
                checked={selectedSupportOptions.includes(option)}
                onChange={handleCheckboxChange}
              />
              <label htmlFor={optionId} className="multistep-form-radio-checkbox-label">{option}</label>
            </div>
          );
        })}
        {error && <p className="text-danger">{error}</p>}
        {/* Navigation Buttons */}
        <div className="mt-5">
  {isHighmarkPortal ? (
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={prevStep}></button>
      <span className="me-3">{step} of {totalSteps}</span>
      <button className="next-btn" onClick={nextStep}></button>
    </div>
  ) : (
    <>
      <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
        {t('back')}
      </button>
      <button className="win-btn-primary mobile-view mb-3" onClick={nextStep}>{t('next')}</button>
    </>
  )}
</div>

      </div>
    </>
  );
};

export default FamilyBuildingSurrogacySupport;
